import { useIntl } from 'react-intl'
import { denominatorDataId, numeratorDataId } from './utils'

export interface CharacterCountProps {
  value: string
  maxChars: number
}

export const CharacterCount = (props: CharacterCountProps) => {
  const intl = useIntl()
  const { value, maxChars } = props
  const numChars = value.length

  const characterCountTitle = intl.formatMessage(
    {
      id: 'inputs.characterCount.title',
      description: 'Inputs - Character Count - Title',
      defaultMessage: '{numChars} out of {maxChars} characters',
    },
    { numChars, maxChars }
  )

  const characterCountCopy = intl.formatMessage(
    {
      id: 'inputs.characterCount.copy',
      description: 'Inputs - Character Count - Copy',
      defaultMessage: '{maxChars} characters',
    },
    { maxChars }
  )

  return (
    <span aria-live="polite" role="status" aria-atomic="true" title={characterCountTitle}>
      <span aria-hidden="true">
        <span data-classname={numeratorDataId}>{numChars}</span>
        {
          // eslint-disable-next-line formatjs/no-literal-string-in-jsx
          '/'
        }
        <span data-classname={denominatorDataId}>{characterCountCopy}</span>
      </span>
    </span>
  )
}
